export * from './gutachten-stati-list.component';
export * from './gutachten-stati-list.component.module';